"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3926],{

/***/ 53926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M8.85.916a1.58 1.58 0 1 1 2.234 2.235l-1.071 1.07 1.4 4.2a1.28 1.28 0 0 1-2.33 1.036l-1.555-2.75L5.26 8.973l.212.404a1.28 1.28 0 0 1-.229 1.499l-.028.028c-.5.5-1.31.5-1.81 0l-2.31-2.31c-.5-.5-.5-1.31 0-1.81l.028-.028a1.28 1.28 0 0 1 1.5-.229l.403.212 2.268-2.268-2.75-1.555A1.28 1.28 0 0 1 3.578.587l4.2 1.4 1.07-1.07Zm1.706 1.707L9.392 3.787a.533.533 0 0 0-.13.546l1.442 4.324a.534.534 0 0 1-.971.432L8.04 6.095a.533.533 0 0 0-.84-.115L4.622 8.557a.533.533 0 0 0-.096.625l.285.542c.108.207.07.46-.096.625l-.028.028a.533.533 0 0 1-.755 0l-2.31-2.31a.533.533 0 0 1 0-.754l.03-.028a.533.533 0 0 1 .624-.095l.542.284c.207.108.46.07.625-.095L6.02 4.8a.533.533 0 0 0-.115-.841L2.911 2.267a.534.534 0 0 1 .432-.971l4.325 1.441a.533.533 0 0 0 .545-.129l1.164-1.164a.833.833 0 1 1 1.179 1.179Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgPlane);

/***/ })

}]);